<template>
  <div style="border: 0px solid black; width:100%;display:block;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;display: contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">
              {{ $t("mail_form_list.title") }}
            </h3>
          </div>
          <div class="box-body">
            <b-table striped hover :fields="fields" :items="items">
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    class="btn btn-primary"
                    style="margin-left: 6px;"
                    @click="onViewTemplate(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
          <div class="box-footer clearfix">
            <!-- <paginator :item="paginatorItem" @onpaginate="onPagination" /> -->
            <paginator
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </row>
    </div>
    <!--  -->
    <email-template ref="emailTemplate" @callbackEmailCategoryList="callbackEmailCategoryList"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Paginator from "@/components/CustomPaginator.vue";
import EmailTemplate from "./EmailTemplate"
import utils from '@/lib/utils';

export default {
  components: {
    paginator: Paginator,
    EmailTemplate
  },
  data: () => ({
    fields: [
      { sortable: false, label: "common.nonumber", key: "nonumber" },
      {
        sortable: false,
        label: "templateNotification.category.table.headerName",
        key: "name"
      },
      {
        sortable: false,
        label: "templateNotification.category.table.headerNumberOfTemplate",
        key: "numberOfTemplate"
      },
      { sortable: false, label: "common.action", key: "actions" }
    ],
    items: [],
    paginatorItem: {
      commit_function: "GET_EMAIL_TEMPLATE_CATEGORY"
    },
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    }
  }),
  watch: {
    GET_EMAIL_TEMPLATE_CATEGORY_DATA: function() {
      let data = this.GET_EMAIL_TEMPLATE_CATEGORY_DATA;
      let results = data.results;
      this.items = [];
      results.forEach((value, index) => {
        let item = {
          id: value.category,
          nonumber: index + 1,
          name: this.getEmailTemplateCatagoryName(value.category),
          numberOfTemplate: value.numberOfTemplate
        };
        this.items.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_EMAIL_TEMPLATE_CATEGORY_DATA"
    ])
  },
  methods: {
    getCategoryList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_EMAIL_TEMPLATE_CATEGORY(filter);
    },
    getEmailTemplateCatagoryName(category) {
      return this.$t(utils.getEmailTemplateCatagoryName(category))
    },
    onViewTemplate: function(data) {
      this.$refs.emailTemplate.onShowTemplateEmail(data.id)
    },
    onPagination: function(data) {
      this.paginateData.currentPage = data.params.page
      this.getCategoryList(data.params.page);
    },
    onPageChange: function() {},
    callbackEmailCategoryList: function() {
      this.getCategoryList(this.paginateData.currentPage)
    },
    ...mapActions([
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_EMAIL_TEMPLATE_CATEGORY"
    ])
  },
  created() {
    this.getCategoryList(1);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Mailbox/EmailCategory.vue